import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Grid, FormControl, InputLabel, Select, MenuItem, Alert, IconButton, Box, Typography } from '@mui/material';
import { hashPassword } from '../../utils/passwordUtils';
interface CreateUserModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (userData: any) => void;
}
const CreateUserModal: React.FC<CreateUserModalProps> = ({
  open,
  onClose,
  onSubmit
}) => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    fullName: '',
    mobileNumber: '+92',
    role: 'maker',
    designation: '',
    branchCode: '',
    settlementAccount: ''
  });
  const [errors, setErrors] = useState<Record<string, string>>({});
  const validateForm = () => {
    const newErrors: Record<string, string> = {};
    if (!formData.username) {
      newErrors.username = 'Username is required';
    }
    const storedUsers = localStorage.getItem('branchUsers');
    if (storedUsers) {
      const users = JSON.parse(storedUsers);
      if (users.some((u: any) => u.username === formData.username)) {
        newErrors.username = 'Username already exists';
      }
    }
    if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Valid email is required';
    }
    if (!formData.fullName) {
      newErrors.fullName = 'Full name is required';
    }
    if (!formData.mobileNumber || !/^\+92\d{10}$/.test(formData.mobileNumber)) {
      newErrors.mobileNumber = 'Mobile number must be +92 followed by 10 digits';
    }
    if (!formData.role) {
      newErrors.role = 'Role is required';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = () => {
    if (!validateForm()) return;
    const hashedOtp = hashPassword('Test01');
    const userData = {
      ...formData,
      hashedOtp,
      firstLoginRequired: true
    };
    onSubmit(userData);
    handleClose();
  };
  const handleClose = () => {
    setFormData({
      username: '',
      email: '',
      fullName: '',
      mobileNumber: '+92',
      role: 'maker',
      designation: '',
      branchCode: '',
      settlementAccount: ''
    });
    setErrors({});
    onClose();
  };
  return <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth data-id="element-2776">
      <DialogTitle data-id="element-2777">
        <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }} data-id="element-2778">
          <Typography variant="h6" data-id="element-2779">Create New User</Typography>
          <IconButton onClick={handleClose} data-id="element-2780">
            <div size={20} data-id="element-2781" />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent data-id="element-2782">
        <Alert severity="info" sx={{
        mb: 3
      }} data-id="element-2783">
          A temporary OTP "Test01" will be generated and the user will be
          required to reset their password on first login.
        </Alert>
        <Grid container spacing={2} data-id="element-2784">
          <Grid item xs={12} md={6} data-id="element-2785">
            <TextField fullWidth required label="Username" value={formData.username} onChange={e => setFormData({
            ...formData,
            username: e.target.value
          })} error={!!errors.username} helperText={errors.username} data-id="element-2786" />
          </Grid>
          <Grid item xs={12} md={6} data-id="element-2787">
            <TextField fullWidth required label="Full Name" value={formData.fullName} onChange={e => setFormData({
            ...formData,
            fullName: e.target.value
          })} error={!!errors.fullName} helperText={errors.fullName} data-id="element-2788" />
          </Grid>
          <Grid item xs={12} md={6} data-id="element-2789">
            <TextField fullWidth required label="Email" type="email" value={formData.email} onChange={e => setFormData({
            ...formData,
            email: e.target.value
          })} error={!!errors.email} helperText={errors.email} data-id="element-2790" />
          </Grid>
          <Grid item xs={12} md={6} data-id="element-2791">
            <TextField fullWidth required label="Mobile Number" value={formData.mobileNumber} onChange={e => {
            const value = e.target.value;
            if (value.startsWith('+92')) {
              setFormData({
                ...formData,
                mobileNumber: value.slice(0, 13)
              });
            }
          }} error={!!errors.mobileNumber} helperText={errors.mobileNumber || '+92 followed by 10 digits'} data-id="element-2792" />
          </Grid>
          <Grid item xs={12} md={6} data-id="element-2793">
            <FormControl fullWidth required error={!!errors.role} data-id="element-2794">
              <InputLabel data-id="element-2795">Role</InputLabel>
              <Select value={formData.role} label="Role" onChange={e => setFormData({
              ...formData,
              role: e.target.value
            })} data-id="element-2796">
                <MenuItem value="maker" data-id="element-2797">Maker</MenuItem>
                <MenuItem value="checker" data-id="element-2798">Checker</MenuItem>
                <MenuItem value="admin" data-id="element-2799">Admin</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} data-id="element-2800">
            <TextField fullWidth label="Designation" value={formData.designation} onChange={e => setFormData({
            ...formData,
            designation: e.target.value
          })} helperText="Optional - can be updated later" data-id="element-2801" />
          </Grid>
          <Grid item xs={12} md={6} data-id="element-2802">
            <TextField fullWidth label="Branch Code" value={formData.branchCode} onChange={e => setFormData({
            ...formData,
            branchCode: e.target.value
          })} helperText="Optional - can be updated via Bank API" data-id="element-2803" />
          </Grid>
          <Grid item xs={12} md={6} data-id="element-2804">
            <TextField fullWidth label="Settlement Account" value={formData.settlementAccount} onChange={e => setFormData({
            ...formData,
            settlementAccount: e.target.value
          })} helperText="Optional - can be updated via Bank API" data-id="element-2805" />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions data-id="element-2806">
        <Button onClick={handleClose} data-id="element-2807">Cancel</Button>
        <Button variant="contained" onClick={handleSubmit} data-id="element-2808">
          Create User
        </Button>
      </DialogActions>
    </Dialog>;
};
export default CreateUserModal;